var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGetYourPersonalImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 168,
    height: 173,
    viewBox: "0 0 168 173",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.219 27.3885C123.219 49.1357 139.997 66.7653 160.692 66.7653C162.971 66.7535 165.244 66.5233 167.483 66.0775V144.143C167.483 176.986 149.074 196.417 117.819 196.417H49.7459C18.4093 196.417 0 176.986 0 144.143V72.6116C0 39.7689 18.4093 20.1665 49.7459 20.1665H123.874C123.434 22.5459 123.215 24.9646 123.219 27.3885ZM103.743 126.862L130.334 90.7525V90.5806C132.611 87.3615 132.03 82.8224 129.025 80.3495C127.571 79.1681 125.723 78.6566 123.903 78.9321C122.084 79.2075 120.448 80.2463 119.37 81.8111L96.952 112.16L71.4244 91.0105C69.967 89.8156 68.113 89.288 66.2809 89.5469C64.4489 89.8057 62.7933 90.8291 61.688 92.3861L34.1968 129.699C33.2305 130.967 32.7103 132.546 32.7241 134.17C32.5645 137.452 34.5341 140.434 37.5163 141.425C40.4984 142.415 43.7411 141.165 45.406 138.383L68.3971 107.088L93.9247 128.152C95.3766 129.384 97.2428 129.942 99.0945 129.699C100.946 129.456 102.624 128.432 103.743 126.862Z",
    fill: "#6322D0"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    opacity: 0.4,
    cx: 163.078,
    cy: 25.0624,
    rx: 22.0116,
    ry: 24.4792,
    fill: "#6322D0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGetYourPersonalImage);
export default __webpack_public_path__ + "static/media/get-your-personal-image.1687db4b34c2fedd140646103e38cda4.svg";
export { ForwardRef as ReactComponent };